import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort-desc",
  "use": "sort-desc-usage",
  "viewBox": "0 0 16 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 28\" id=\"sort-desc\"><path fill=\"currentColor\" d=\"M16 17a.99.99 0 01-.297.703l-7 7C8.516 24.89 8.265 25 8 25s-.516-.109-.703-.297l-7-7A.996.996 0 010 17c0-.547.453-1 1-1h14c.547 0 1 .453 1 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol